import React, { useState, useEffect } from "react";
import Typography from '@mui/material/Typography';
import axios from "axios";

import SubHeader from "./../subHeader/SubHeader";
import IdCardForm from "./../idCardForm/IdCardForm";
import IdCardFront from "./../idCardFront/IdCardFront";
import IdCardBack from "./../idCardBack/IdCardBack";
import Helpdesk from "./../helpdesk/Helpdesk";
import Loader from "./../loader/Loader";
import Error from "./../error/Error";
import "./Home.css";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const Home = ({ getUser, getAccessToken, createSnackbar }) => {
  const { REACT_APP_BACKEND_URL } = JSON.parse(process.env.REACT_APP_IDCG_ENV)["frontend"];

  const [userImage, setUserImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [user, setUser] = useState({
    name: "",
    empId: "",
    bloodGroup: "",
    pronouns: "",
    croppedImage: "",
    homeOfficeLocation: "",
    role: ""
  });
  const [bloodGroupList, setBloodGroupList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [imageMaxSize, setImageMaxSize] = useState(0);
  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = async () => {
    try {
      const { data: { user: { role, employeeNumber }, acceptedBloodGroup, acceptedOfficeLocation, maxImageSize } } = await axios.get(`${REACT_APP_BACKEND_URL}/userInfo`, {
        withCredentials: true,
        headers: {
          'Authorization': `Bearer ${await getAccessToken()}`
        }
      });

      const { name } = await getUser();

      setBloodGroupList(acceptedBloodGroup);
      setAddressList(acceptedOfficeLocation);
      setImageMaxSize(maxImageSize);

      setUser({
        name: role === "admin" ? "" : name,
        empId: role === "admin" ? "" : employeeNumber,
        bloodGroup: "",
        pronouns: "",
        croppedImage: "",
        homeOfficeLocation: "",
        role: role
      });

      setLoading(false);
      if (role === "admin") {
        createSnackbar.success(`Logged in as admin`);
      }
    } catch (err) {
      setLoading(false);
      setShowError(true);
    }
  }

  const handleDetailChange = (field, value) => {
    setUser((user) => ({ ...user, [field]: value }));
  };

  const handleFullImage = (fullImage) => {
    setUserImage(fullImage);
  };

  const handleCroppedImage = (croppedImage) => {
    handleDetailChange("croppedImage", croppedImage)
  };

  const handleHomePage = () => {
    if (loading) {
      return <Loader />;
    }
    if (showError) {
      return <Error />;
    }

    return (
      <div className="home">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={7}>
              <SubHeader role={user.role} />
              <div className="home__container">
                <div className="main-content">
                  <IdCardForm
                    user={user}
                    onDetailChange={handleDetailChange}
                    croppedImage={handleCroppedImage}
                    fullImage={handleFullImage}
                    userImage={userImage}
                    REACT_APP_BACKEND_URL={REACT_APP_BACKEND_URL}
                    getUser={getUser}
                    getAccessToken={getAccessToken}
                    createSnackbar={createSnackbar}
                    bloodGroupList={bloodGroupList}
                    addressList={addressList}
                    imageMaxSize={imageMaxSize}
                  />
                  <div>
                    <Typography variant="subtitle1" component="p" fontWeight="fontWeightBold">
                      Preview
                    </Typography>
                    <div className="id__card__preview">
                      {/* <div className="id__card__preview__heading">
                  <Typography variant="body1" component="p" fontWeight="fontWeightBold" color="text.secondary">
                    Preview
                  </Typography>
                </div> */}
                      <div className="id__card__preview__cards">
                        <IdCardFront user={user} />
                        <IdCardBack user={user} addressList={addressList} />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="home__container">
                <Helpdesk user={user} createSnackbar={createSnackbar} addressList={addressList} />
              </div>
              <div className="home__container">
                <Typography variant="body1" component="p">
                  For any queries or feedback please reach out at <b>indiafacilities@thoughtworks.com</b>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Box>

      </div>
    )
  }

  return (
    <>
      {handleHomePage()}
    </>
  );
}

export default Home;
